import React from 'react';
import {
  ITransfersListBlock,
  TransfersListBlock
} from './blocks/transfers-list-block';

// Thin wrapper — keeps the same public API so all existing callers
// (dashboard, home page, future account page) need no changes.
export type TransfersPageProps = ITransfersListBlock;

export function TransfersPage(props: TransfersPageProps = {}) {
    return <TransfersListBlock {...props} />;
}
